// The floating in-game surface. Everything that hovers over the board is one
// of these — objectives, inspector, the build flyout, the orders popover, the
// pause plate (screen-mock `.panel`).
//
// **Translucent is the default, and it is the panel token with alpha over it**
// rather than a second, darker colour. The sheet writes `#24252bee`; that is
// `--panel` at 93%, so saying it as a mix keeps one source of colour truth and
// lets a palette change move the glass with it.
//
// `solid` is the opaque variant (kit-sheet `.demo`), for a surface that is not
// over the board and has nothing to let through.

import { styled } from "@mui/material/styles";

export const Panel = styled("div", {
  shouldForwardProp: (prop: string) => prop !== "solid"
})<{ solid?: boolean }>(({ theme, solid }) => ({
  background: solid
    ? theme.kit.color.panel
    : `color-mix(in srgb, ${theme.kit.color.panel} 93%, transparent)`,
  ...(solid ? {} : { backdropFilter: "blur(6px)" }),
  border: `2px solid ${theme.kit.color.line}`,
  borderRadius: theme.kit.radius.md,
  color: theme.kit.color.ink,
  fontFamily: theme.kit.font.body
}));
